import React, { FunctionComponent, PropsWithChildren, useEffect } from 'react';
import * as classes from './layout.module.scss';
import { Header } from './Header';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Footer } from './Footer';
import { LanguageMetaTags } from './LanguageMetaTags';
import { SiteViewTrackingOptions, useTrackPageView } from '../../matomo';
import { SkipLink } from '../Navigation';
import { ISeoProps, Seo } from '../Seo';
import clsx from 'clsx';

interface ILayoutProps {
    title: string;
    headerContent?: React.ReactNode;
    trackSiteView?: SiteViewTrackingOptions;
    seoProps?: Partial<ISeoProps>;
    className?: string;
}

export const Layout: FunctionComponent<PropsWithChildren<ILayoutProps>> = (props) => {
    const { t } = useTranslation('common');

    useTrackPageView(props.trackSiteView);

    // https://github.com/gatsbyjs/gatsby/issues/29037
    useEffect(() => {
        const gatsbyFocusWrapper = document.getElementById('gatsby-focus-wrapper');
        if (gatsbyFocusWrapper) {
            gatsbyFocusWrapper.removeAttribute('style');
            gatsbyFocusWrapper.removeAttribute('tabIndex');
        }
    }, []);

    return <div className={classes.layoutContainer}>
        <LanguageMetaTags/>
        <Seo
            title={props.title}
            {...props.seoProps}
        />

        <SkipLink target="main">{t('common:skipLink.content')}</SkipLink>

        <Header>
            {props.headerContent}
        </Header>

        <main className={clsx(props.className, classes.main)} id="main">
            {props.children}
        </main>

        <Footer/>
    </div>;
};
